import React from "react";
import { Route, Redirect } from "react-router-dom";

import Login from "../views/Auth/Login.js";

const Auth = () => {
    return (
        <>
            <Route path="/auth/login" exact component={Login} />
            <Route path="/login/callback" />
            <Redirect from="/auth" to="/auth/login" />
        </>
        //Footer
    );
};

export default Auth;
